<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-warning">
                        <div class="card-icon">
                            <i class="material-icons">warning</i>
                        </div>
                        <h4 class="card-title">Assembléias a Vencer em {{ deadline }} {{ deadline > 1 ? 'dias' : 'dia' }}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <table aria-busy="false" aria-colcount="5" class="table b-table table-striped table-hover table-bordered table-sm b-table-fixed">
                                    <thead role="rowgroup" class="">
                                        <tr role="row">
                                            <th role="columnheader" scope="col" aria-colindex="1" class="">Grupo</th>
                                            <th role="columnheader" scope="col" aria-colindex="2" class="">Cota</th>
                                            <th role="columnheader" scope="col" aria-colindex="3" class="">Assembléia</th>
                                            <th role="columnheader" scope="col" aria-colindex="4" class="">Administradora</th>
                                            <th role="columnheader" scope="col" aria-colindex="5" class="">Proposta</th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup" class="">
                                        <tr v-for="item in items.slice(initMeeting, endMeeting)" role="row" class="">
                                            <td role="cell" aria-colindex="1" class="">{{ item.group.name }}</td>
                                            <td role="cell" aria-colindex="2" class="">{{ item.quote }}</td>
                                            <td role="cell" aria-colindex="3" class="">{{ item.group.meeting_at | moment('DD/MM/YYYY') }}</td>
                                            <td role="cell" aria-colindex="4" class="">{{ item.administrator.name }}</td>
                                            <td role="cell" aria-colindex="5" class="">{{ item.physical_proposal }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <b-pagination
                            v-model="currentPageMeeting"
                            :total-rows="items.length"
                            :per-page="perPage"
                            align="right"
                            @change="pageChangeMeeting"
                            ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-success">
                        <div class="card-icon" v-b-toggle.filter>
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title">Acompanhar Clientes</h4>
                    </div>
                    <div class="card-body">
                        <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                            <b-collapse id="filter">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="interval" class="bmd-label-floating">Intervalo Data</label>
                                            <date-picker
                                                range
                                                v-model="form.interval"
                                                lang="pt-br"
                                                format="DD/MM/YYYY"
                                                placeholder="Escolha uma data"
                                                ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="team_id" class="bmd-label-floating">Equipe</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="teams"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.team_id"
                                                ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="salesmans" class="bmd-label-floating">Vendedor</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="salesmans"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.salesman_id"
                                                ></model-list-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="administrators"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.administrator_id"
                                                ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="proposal_status" class="bmd-label-floating">Status da Proposta</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="proposalStatus"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.proposal_status_id"
                                                ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group"
                                             v-bind:class="{'is-filled': form.client.name != null}">
                                            <label for="name" class="bmd-label-floating">Cliente *</label>
                                            <input refs="name" type="text" class="form-control" v-model="form.client.name" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                                        <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
                                    </div>
                                </div>
                                <hr />
                            </b-collapse>
                        </b-form>
                        <div>
                            <table role="table" class="table b-table table-striped table-hover">
                                <thead role="rowgroup">
                                    <tr role="row">
                                        <th rol="columheader" scope="col" aria-colindex="1">Cliente<br />Contato</th>
                                        <th rol="columheader" scope="col" aria-colindex="2">Contrato<br />Data Venda</th>
                                        <th rol="columheader" scope="col" aria-colindex="3">Grupo<br />Cota</th>
                                        <th rol="columheader" scope="col" aria-colindex="4">Vendedor<br />Supervisor</th>
                                        <th rol="columheader" scope="col" aria-colindex="5">1ª Parcela<br />Quitada</th>
                                        <th rol="columheader" scope="col" aria-colindex="6">2ª Parcela<br />Quitada</th>
                                        <th rol="columheader" scope="col" aria-colindex="7">3ª Parcela<br />Quitada</th>
                                        <th rol="columheader" scope="col" aria-colindex="8">4ª Parcela<br />Quitada</th>
                                        <th rol="columheader" scope="col" aria-colindex="9">5ª Parcela<br />Quitada</th>
                                        <th rol="columheader" scope="col" aria-colindex="10">Valor da Carta</th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    <tr role="row" v-for="proposal in proposals.slice(init, end)" :key="proposal.id">
                                        <td role="cell" aria-colindex="1">{{ proposal.client.name }}<br />{{ proposal.client.cell_phone | phone }}</td>
                                        <td role="cell" aria-colindex="2">{{ proposal.physical_proposal }}<br />{{ proposal.sale_at | moment('DD/MM/YYYY') }}</td>
                                        <td role="cell" aria-colindex="3">{{ proposal.group ? proposal.group.name : '-' }}<br />{{ proposal.quota }}</td>
                                        <td role="cell" aria-colindex="4">{{ proposal.salesman ? proposal.salesman.name : '-' }}<br />{{ proposal.supervisor_name ? proposal.supervisor_name : '-' }}</td>
                                        <td role="cell" aria-colindex="5"><installment v-bind:installment="getInstallment(proposal.installments, 1)"></installment></td>
                                        <td role="cell" aria-colindex="5"><installment v-bind:installment="getInstallment(proposal.installments, 2)"></installment></td>
                                        <td role="cell" aria-colindex="5"><installment v-bind:installment="getInstallment(proposal.installments, 3)"></installment></td>
                                        <td role="cell" aria-colindex="5"><installment v-bind:installment="getInstallment(proposal.installments, 4)"></installment></td>
                                        <td role="cell" aria-colindex="5"><installment v-bind:installment="getInstallment(proposal.installments, 5)"></installment></td>
                                        <td role="cell" aria-colindex="10">R$ {{ proposal.value | price }}</td>
                                    </tr>
                                </tbody>
                                <tfoot role="rowgroup">
                                    <tr role="row">
                                        <th role="columnheader" scope="col" aria-colindex="1" colspan="9"><strong>Total</strong></th>
                                        <th role="columnheader" scope="col" aria-colindex="10"><strong>R$ {{ sumValueProposals(proposals) | price }}</strong></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="proposals.length"
                                    :per-page="perPage"
                                    aria-controls="my-table"
                                    align="right"
                                    @change="pageChange"
                                    ></b-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer hidden-sm-only">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-10 offset-md-2">
                                    <table aria-busy="false" aria-colcount="6" class="table b-table table-striped table-hover table-bordered table-sm b-table-fixed">
                                        <thead role="rowgroup" class="">
                                            <tr role="row">
                                                <th role="columnheader" scope="col" aria-colindex="1" aria-label="Title" class=""></th>
                                                <th role="columnheader" scope="col" aria-colindex="2" class="">1ª Parcela</th>
                                                <th role="columnheader" scope="col" aria-colindex="3" class="">2ª Parcela</th>
                                                <th role="columnheader" scope="col" aria-colindex="4" class="">3ª Parcela</th>
                                                <th role="columnheader" scope="col" aria-colindex="5" class="">4ª Parcela</th>
                                                <th role="columnheader" scope="col" aria-colindex="6" class="">5ª Parcela</th>
                                            </tr>
                                        </thead>
                                        <tbody role="rowgroup" class="">
                                            <tr role="row" class="">
                                                <td role="cell" aria-colindex="1" class="">Qtde Total Devida</td>
                                                <td role="cell" aria-colindex="2" class="text-center">{{ countInstallment(proposals, 1) }}</td>
                                                <td role="cell" aria-colindex="3" class="text-center">{{ countInstallment(proposals, 2) }}</td>
                                                <td role="cell" aria-colindex="4" class="text-center">{{ countInstallment(proposals, 3) }}</td>
                                                <td role="cell" aria-colindex="5" class="text-center">{{ countInstallment(proposals, 4) }}</td>
                                                <td role="cell" aria-colindex="6" class="text-center">{{ countInstallment(proposals, 5) }}</td>
                                            </tr>
                                            <tr role="row" class="">
                                                <td role="cell" aria-colindex="1" class="">Qtde Total Recebida</td>
                                                <td role="cell" aria-colindex="2" class="text-center">{{ countInstallment(proposals, 1, true) }}</td>
                                                <td role="cell" aria-colindex="3" class="text-center">{{ countInstallment(proposals, 2, true) }}</td>
                                                <td role="cell" aria-colindex="4" class="text-center">{{ countInstallment(proposals, 3, true) }}</td>
                                                <td role="cell" aria-colindex="5" class="text-center">{{ countInstallment(proposals, 4, true) }}</td>
                                                <td role="cell" aria-colindex="6" class="text-center">{{ countInstallment(proposals, 5, true) }}</td>
                                            </tr>
                                            <tr role="row" class="">
                                                <td role="cell" aria-colindex="1" class="">Perc. Ref. a Qtd. Recebida ({{ percentInstallmentsPay(proposals) | price }}%)</td>
                                                <td role="cell" aria-colindex="2" class="text-center">{{ percentInstallmentsPay(proposals, 1) | price }} %</td>
                                                <td role="cell" aria-colindex="3" class="text-center">{{ percentInstallmentsPay(proposals, 2) | price }} %</td>
                                                <td role="cell" aria-colindex="4" class="text-center">{{ percentInstallmentsPay(proposals, 3) | price }} %</td>
                                                <td role="cell" aria-colindex="5" class="text-center">{{ percentInstallmentsPay(proposals, 4) | price }} %</td>
                                                <td role="cell" aria-colindex="6" class="text-center">{{ percentInstallmentsPay(proposals, 5) | price }} %</td>
                                            </tr>
                                            <tr role="row" class="">
                                                <td role="cell" aria-colindex="1" class="">Valor Total Devido</td>
                                                <td role="cell" aria-colindex="2" class="text-center">R$ {{ calcValueInstallment(proposals, 1) | price }}</td>
                                                <td role="cell" aria-colindex="3" class="text-center">R$ {{ calcValueInstallment(proposals, 2) | price }}</td>
                                                <td role="cell" aria-colindex="4" class="text-center">R$ {{ calcValueInstallment(proposals, 3) | price }}</td>
                                                <td role="cell" aria-colindex="5" class="text-center">R$ {{ calcValueInstallment(proposals, 4) | price }}</td>
                                                <td role="cell" aria-colindex="6" class="text-center">R$ {{ calcValueInstallment(proposals, 5) | price }}</td>
                                            </tr>
                                            <tr role="row" class="">
                                                <td role="cell" aria-colindex="1" class="">Valor Total Recebido</td>
                                                <td role="cell" aria-colindex="2" class="text-center">R$ {{ calcValueInstallment(proposals, 1, true) | price }}</td>
                                                <td role="cell" aria-colindex="3" class="text-center">R$ {{ calcValueInstallment(proposals, 2, true) | price }}</td>
                                                <td role="cell" aria-colindex="4" class="text-center">R$ {{ calcValueInstallment(proposals, 3, true) | price }}</td>
                                                <td role="cell" aria-colindex="5" class="text-center">R$ {{ calcValueInstallment(proposals, 4, true) | price }}</td>
                                                <td role="cell" aria-colindex="6" class="text-center">R$ {{ calcValueInstallment(proposals, 5, true) | price }}</td>
                                            </tr>
                                            <tr role="row" class="">
                                                <td role="cell" aria-colindex="1" class="">Perc. Ref. ao Valor Recebido ({{ percentValueInstallmentsPay(proposals) | price }}%)</td>
                                                <td role="cell" aria-colindex="2" class="text-center">{{ percentValueInstallmentsPay(proposals, 1) | price }}%</td>
                                                <td role="cell" aria-colindex="3" class="text-center">{{ percentValueInstallmentsPay(proposals, 2) | price }}%</td>
                                                <td role="cell" aria-colindex="4" class="text-center">{{ percentValueInstallmentsPay(proposals, 3) | price }}%</td>
                                                <td role="cell" aria-colindex="5" class="text-center">{{ percentValueInstallmentsPay(proposals, 4) | price }}%</td>
                                                <td role="cell" aria-colindex="6" class="text-center">{{ percentValueInstallmentsPay(proposals, 5) | price }}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cockpit-leads />
        <cockpit-proposals />
    </div>
</template>

<script>
    import JwtService from "@/services/jwt.service";
    import Installment from '@/components/elements/Installment';
    import CockpitLeads from '@/components/elements/cockpits/Leads';
    import CockpitProposals from '@/components/elements/cockpits/Proposals';
    import Vue from 'vue';
    import UserService from "@/services/modules/users.service";

    export default {
        components: {
            'installment': Installment,
            'cockpit-leads': CockpitLeads,
            'cockpit-proposals': CockpitProposals
        },
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            proposals: {
                get() {
                    return this.$store.state.proposals.itens;
                }
            },
            proposalStatus: {
                get() {
                    return this.$store.state.defaults.proposal_status;
                }
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        data() {
            return {
                currentPage: 1,
                currentPageMeeting: 1,
                deadline: 5,
                end: 5,
                endMeeting: 5,
                form: {
                    administrator_id: null,
                    client: {
                        name: null
                    },
                    interval: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    proposal_status_id: null,
                    salesman_id: null,
                    team_id: null
                },
                init: 0,
                initMeeting: 0,
                items: [],
                perPage: 5,
                salesmans: [],
                total: 0
            }
        },
        methods: {
            calcValueInstallment(_proposals, _installmentOrder, _pay) {
                var valueInstallments = 0;

                _proposals.forEach(function (_proposal, _key) {
                    _proposal.installments.forEach(function (_installment) {
                        if (_installment.order == _installmentOrder) {
                            if (_pay !== undefined && _pay) {
                                if (_installment.pay_at !== null) {
                                    valueInstallments += _installment.price;
                                }
                            } else {
                                valueInstallments += _installment.price;
                            }
                        }
                    });
                });

                return valueInstallments;
            },
            countInstallment(_proposals, _installmentOrder, _pay) {
                var numInstallments = 0;
                _proposals.forEach(function (_proposal, _key) {
                    _proposal.installments.forEach(function (_installment, _keyInstallment) {
                        if (_installment.order == _installmentOrder) {
                            if (_pay !== undefined && _pay) {
                                if (_installment.pay_at !== null) {
                                    numInstallments++;
                                }
                            } else {
                                numInstallments++;
                            }
                        }
                    });
                });

                return numInstallments;
            },
            async getConfigurations() {
                const self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch("configurations/all");

                response.then(function () {
                    self.form.interval = [Vue.moment().subtract(self.$store.state.configurations.model.client_follow_up, "days"), Vue.moment()],
                    self.$root.$emit("onLoading");
                    self.getData();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");
                    self.getData();
                });
            },
            async getData() {
                var self = this;

                self.$root.$emit("onLoading");

                self.form.branch_id = JwtService.getBranchId();
                self.currentPage = 1;
                self.init = 0;
                self.end = self.init + self.perPage;

                const response = self.$store.dispatch("proposals/all", {
                    params: self.form
                });

                response.then(function (_data) {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");
                });
            },
            async getDataAdministrators() {
                var self = this;

                if (self.administrators.length === 0) {

                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch('administrators/all');

                    response.then(function () {
                        self.$root.$emit("onLoading");

                        self.getDataProposalStatus();
                    });

                    response.catch(function () {
                        self.$root.$emit("onLoading");

                        self.getDataProposalStatus();
                    });
                } else {
                    self.getDataProposalStatus();
                }
            },
            async getDataProposalDues() {
                var self = this;

                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch("proposals/deadline", {
                    params: {
                        assembly_deadline: self.deadline
                    }
                });

                response.then(function (_data) {
                    self.items = _data;
                    self.$root.$emit("onLoading");

                    self.getConfigurations();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");

                    self.getConfigurations();
                });
            },
            async getDataProposalStatus() {
                var self = this;

                if (self.proposalStatus.length === 0) {

                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch("defaults/proposalStatus");

                    response.then(function () {
                        self.$root.$emit("onLoading");

                        self.getDataProposalDues();
                    });

                    response.catch(function () {
                        self.$root.$emit("onLoading");

                        self.getDataProposalDues();
                    });
                } else {
                    self.getDataProposalDues();
                }
            },
            async getDataSalesmans() {
                var self = this;

                self.$root.$emit("onLoading");

                var params =
                        "branch_id=" +
                        JwtService.getBranchId() +
                        "&type_profile_id=" +
                        UserService.typeProfiles.salesman;

                const response = UserService.all(params);

                response.then(function (_users) {
                    self.salesmans = _users;
                    self.$root.$emit("onLoading");

                    self.getDataTeams();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");

                    self.getDataTeams();
                });
            },
            async getDataTeams() {
                var self = this;

                if (self.teams.length === 0) {

                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch('teams/all');

                    response.then(function () {
                        self.$root.$emit("onLoading");

                        self.getDataAdministrators();
                    });

                    response.catch(function () {
                        self.$root.$emit("onLoading");

                        self.getDataAdministrators();
                    });
                } else {
                    self.getDataAdministrators();
                }
            },
            getInstallment(_installments, _order) {
                return _installments.find(installment => installment.order == _order);
            },
            pageChange(_pageNum) {
                var self = this;

                self.currentPage = _pageNum;

                self.init = (_pageNum - 1) * self.perPage;
                self.end = self.init + self.perPage;
            },
            pageChangeMeeting(_pageNum) {
                var self = this;

                self.currentPageMeeting = _pageNum;

                self.initMeeting = (_pageNum - 1) * self.perPage;
                self.endMeeting = self.initMeeting + self.perPage;
            },
            percentInstallmentsPay(_proposals, _installmentOrder) {
                var numInstallments = 0;
                var numInstallmentsPay = 0;

                _proposals.forEach(function (_proposal, _key) {
                    _proposal.installments.forEach(function (_installment, _keyInstallment) {
                        if (_installmentOrder !== undefined) {
                            if (_installment.order === _installmentOrder) {
                                numInstallments++;
                                if (_installment.pay_at != null) {
                                    numInstallmentsPay++;
                                }
                            }
                        } else if (_installment.order < 6) {
                            numInstallments++;
                            if (_installment.pay_at !== null) {
                                numInstallmentsPay++;
                            }
                        }
                    });
                });

                return (numInstallmentsPay / numInstallments) * 100;
            },
            percentValueInstallmentsPay(_proposals, _installmentOrder) {
                var valueInstallments = 0;
                var valueInstallmentsPay = 0;

                _proposals.forEach(function (_proposal, _key) {
                    _proposal.installments.forEach(function (_installment, _keyInstallment) {
                        if (_installmentOrder !== undefined) {
                            if (_installment.order === _installmentOrder) {
                                valueInstallments += _installment.price;
                                if (_installment.pay_at != null) {
                                    valueInstallmentsPay += _installment.price;
                                }
                            }
                        } else if (_installment.order < 6) {
                            valueInstallments += _installment.price;
                            if (_installment.pay_at !== null) {
                                valueInstallmentsPay += _installment.price;
                            }
                        }
                    });
                });

                return (valueInstallmentsPay / valueInstallments) * 100;
            },
            sumValueProposals: function(_proposals) {
                var value = 0;

                _proposals.forEach(function(_proposal){
                    value += parseFloat(_proposal.value);
                });

                return value;
            },
            onReset: function (_ev) {
                _ev.preventDefault();

                var self = this;

                self.form = {
                    administrator_id: null,
                    client: {
                        name: null
                    },
                    interval: [Vue.moment().subtract(self.$store.state.configurations.model.client_follow_up, "days"), Vue.moment()],
                    proposal_status_id: null,
                    salesman_id: null,
                    team_id: null
                };

                self.currentPage = 1;

                self.getData();
            },
            onSubmit: function (_ev) {
                _ev.preventDefault();

                var self = this;

                self.currentPage = 1;

                self.getData();
            }
        },
        mounted() {
            var self = this;

            self.getDataSalesmans();

            self.$root.$on("changeBranch", self.getDataSalesmans);
        },
        destroyed () {
            var self = this;

            self.$root.$off("changeBranch", self.getDataSalesmans);
        }
    }
</script>
<style type="scss" scoped>
    .text-right{
        float: right;
        width: auto;
    }
</style>